module.exports = __webpack_public_path__ + "fonts/VetoSansCond-LightItalic_1.534893ea.woff2";